import { render, staticRenderFns } from "./ExDetail.vue?vue&type=template&id=6fdc6d4d&scoped=true&"
import script from "./ExDetail.vue?vue&type=script&lang=js&"
export * from "./ExDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExDetail.vue?vue&type=style&index=0&id=6fdc6d4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc6d4d",
  null
  
)

export default component.exports